import { Drawer, DrawerContent, Portal } from '@chakra-ui/react';
import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import {
  BoardExplore,
  useBoardExpStore,
} from '@sketch-note/design-system/src/components/board-exp';
import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';
import cn from 'classnames';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { QuickHelp } from 'src/components/quick-help';
import { Settings } from 'src/components/settings';
import { SideBar } from 'src/components/sidebar';
import { Notifications } from 'src/features/notifications';
import { useAuth } from 'src/shared/hooks/use-auth';
import { useLayout } from 'src/shared/hooks/use-layout';
import { TOGGLE_SIDEBAR } from 'src/store/types';

export const TaskLayout = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => {
  const authData = useAuth((s) => s.userDetails);
  const {
    currentSettingsMenu,
    isHelpOpened,
    isNotificationsOpened,
    isSettingsOpened,
    isSidebarOpened,
    onCloseHelp,
    onCloseNotifications,
    onCloseSettings,
    onOpenNotificationSettings,
    onOpenSettings,
  } = useLayout();

  const { isExploreOpen } = useBoardExpStore();

  const dispatch = useDispatch();

  function handleToggleSideBar() {
    dispatch({ type: TOGGLE_SIDEBAR });
  }

  return (
    <div
      className={cn('', {
        'relative flex flex-1 w-full h-full': true,
      })}
    >
      <div className={cn({ 'h-screen ': true, 'w-296': isSidebarOpened })}>
        <SideBar
          handleToggleSideBar={handleToggleSideBar}
          isOpen={isSidebarOpened}
          catalogHref={Navigation.Catalogue.href}
        />
      </div>
      <div
        className={cn({
          'w-full h-full flex-col overflow-hidden': true,
        })}
      >
        {isExploreOpen ? (
          <div
            style={{ minWidth: '38rem', maxWidth: '38rem' }}
            className="bg-white h-full absolute right-0 shadow-xl mt-2 overflow-y-auto z-30 px-24"
          >
            <BoardExplore />
          </div>
        ) : null}

        <Drawer
          size="lg"
          isOpen={isNotificationsOpened}
          placement="right"
          onClose={onCloseNotifications}
        >
          <Portal>
            <DrawerContent className="overflow-auto">
              {authData?.authentication === 'authorised' && <Notifications />}
            </DrawerContent>
          </Portal>
        </Drawer>

        <Modal isOpen={isSettingsOpened} onClose={onCloseSettings}>
          <ModalOverlay />
          <ModalContent
            width="auto"
            maxWidth="auto"
            margin="auto"
            borderRadius="0.8rem"
            className="static rounded-lg"
          >
            <ModalBody className="flex items-center justify-center text-left" padding="0px">
              <Settings
                currentMenu={currentSettingsMenu}
                isOpen={isSettingsOpened}
                onClose={onCloseSettings}
              />
            </ModalBody>
          </ModalContent>
        </Modal>

        <Drawer size="lg" isOpen={isHelpOpened} placement="right" onClose={onCloseHelp}>
          <DrawerContent className="overflow-auto">
            <QuickHelp onClose={onCloseHelp} onClickReset={onOpenSettings} />
          </DrawerContent>
        </Drawer>

        {children}
      </div>
    </div>
  );
};
